import { ImgProps } from "assets/images/types";

export default function ImgDoriana(props: ImgProps) {
	const { height = 48, width = 152 } = props;
	return (
		<img
			src="/assets/images/companies/doriana.webp"
			alt="Doriana logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
